import angular from 'angular';
import HistoryChartComponent from './historyChart.component';

const historyChartModule = angular.module('tinaba.common.historyChart', [])

.component('historyChart', HistoryChartComponent);

export default historyChartModule;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/historyChart/historyChart.js
 **/